/*jslint browser: true, plusplus: true*/
/*global $, jQuery, alert*/

export const sb_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();